



























































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { getStore } from '../store';
import { useRouter } from '../router';

const componentName = 'PasswordUpdate';

export default defineComponent({
    name: componentName,
    
    setup(context) {
        const store = getStore(), { router, route } = useRouter();

        const state = reactive({
            form: {
                password: '',
                passwordConfirm: ''
            },
            passwordUpdateError: false,
            passwordUpdateProgress: false
        });

        const isRegistration = computed( () => {
            return route.value.query.r == '1';
        });

        const onPasswordUpdateClick = async () => {
            state.passwordUpdateProgress = true;

            const clientId = route.value.query.client_id;
            const returnUrl = route.value.query.returnUrl;
            let response = await store.dispatch('passwordUpdate', {
                userId: route.value.query.u,
                code: route.value.query.c,
                password: state.form.password
            });

            state.passwordUpdateProgress = false;

            if (response.result == 'OK') {
                router.replace({ name: 'access-password-update-confirm', query: route.value.query });
            }
            else {
                state.passwordUpdateError = true;
            }
        };

        const submitEnabled = computed(() => {
            return !!state.form.password && state.form.password == state.form.passwordConfirm;
        });

        const passwordRecoveryRoute = computed(() => {
            return { name: 'access-password-recovery', query: route.value.query };
        });

        return {
            state,
            onPasswordUpdateClick,
            isRegistration,
            submitEnabled,
            passwordRecoveryRoute
        }
    }
})
